import { render, staticRenderFns } from "./selected-modal.vue?vue&type=template&id=3b419ddf&"
import script from "./selected-modal.vue?vue&type=script&lang=ts&"
export * from "./selected-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "selected-modal.vue"
export default component.exports